// Models TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
// @ts-ignore
import dayjs, { Dayjs } from "dayjs";
import InterfaceConstructor from './InterfaceConstructor';
import BinInfoDTO from './BinInfoDTO';

interface GrowerDTO {
    growerID: number;
    growerName: string | null;
    isActive: boolean;
    isExternal: boolean;
    externalId: string | null;
    dealerId: string | null;
    externalBinIds: number[];
    notes: string | null;
    bins: BinInfoDTO[] | null;
}
const GrowerDTO: InterfaceConstructor<GrowerDTO> = {
    create: (initValues?: {} | null | undefined) => {
        return Object.assign(
        {
            growerID: 0,
            growerName: null,
            isActive: false,
            isExternal: false,
            externalId: null,
            dealerId: null,
            externalBinIds: [],
            notes: null,
            bins: [],
        },
        initValues);
    }
};

export default GrowerDTO;
